import React, { useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Button,
    Paper,
    Grid
} from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';

const AdjustMenu = () => {
     const [saving, setSaving] = useState(false);
      const [loading, setLoading] = useState(false);
    const [menuItems, setMenuItems] = useState([
        { id: 1, label: 'Home', submenuCount: 0 },
        { id: 2, label: 'Scheduling', submenuCount: 8 },
        { id: 3, label: 'Member Management', submenuCount: 5 },
        { id: 4, label: 'Availability', submenuCount: 4 },
        { id: 5, label: 'Inventory', submenuCount: 5 },
        { id: 6, label: 'NERIS', submenuCount: 4 },
        { id: 7, label: 'Payroll', submenuCount: 2 },
        { id: 8, label: 'Configuration', submenuCount: 2 },
        { id: 9, label: 'Reports', submenuCount: 0 },
        { id: 10, label: 'Messages', submenuCount: 0 },
    ]);

    const moveItem = (index, direction) => {
        const newItems = [...menuItems];
        const targetIndex = direction === 'up' ? index - 1 : index + 1;

        if (targetIndex >= 0 && targetIndex < newItems.length) {
            [newItems[index], newItems[targetIndex]] = [newItems[targetIndex], newItems[index]];
            setMenuItems(newItems);
        }
    };

    const handleSave = () => {
        console.log('Menu order saved:', menuItems);
        // Add your API call here to save the order
    };

    const handleCancel = () => {
        console.log('Changes cancelled');
        // Reset to original order or navigate away
    };

    return (
        <Paper className="p-4" style={{ marginTop: "1rem" }}>
            <Box
                sx={{
                    width: '100%',
                    // maxWidth: 960,
                    mx: 'auto',
                    p: 3,
                    bgcolor: '#f5f5f5',
                    minHeight: '100vh'
                }}
            >
                {/* Header */}
                <Box sx={{ mb: 3 }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 600,
                            mb: 1,
                            color: '#1a1a1a'
                        }}
                    >
                        Adjust Menu
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#666'
                        }}
                    >
                        Drag and drop menu items or use arrow buttons to reorder your navigation
                    </Typography>
                </Box>

                {/* Menu Items List */}
                <Box sx={{ mb:1 }}>
                    {menuItems.map((item, index) => (
                        <Paper
                            key={item.id}
                            elevation={0}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                bgcolor: '#fff',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    borderColor: '#bdbdbd',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                }
                            }}
                        >
                            {/* Left Section - Drag Handle & Info */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                                <DragIndicatorIcon
                                    sx={{
                                        color: '#9e9e9e',
                                        cursor: 'grab',
                                        '&:active': { cursor: 'grabbing' }
                                    }}
                                />

                                <Box>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontWeight: 300,
                                            color: '#1a1a1a',
                                            // mb: 0.5
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                    {item.submenuCount > 0 && (
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: '#666',
                                                // fontSize: '12px'
                                            }}
                                        >
                                            {item.submenuCount} submenu items
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            {/* Right Section - Order Number & Arrows */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#9e9e9e',
                                        minWidth: 30,
                                        textAlign: 'center',
                                        fontSize: '13px'
                                    }}
                                >
                                    #{index + 1}
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        // flexDirection: 'column',
                                        gap: 0.5
                                    }}
                                >
                                    <IconButton
                                        size="small"
                                        onClick={() => moveItem(index, 'up')}
                                        disabled={index === 0}
                                        sx={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '4px',
                                            width: 28,
                                            height: 28,
                                            '&:hover': {
                                                bgcolor: '#f5f5f5',
                                                borderColor: '#bdbdbd'
                                            },
                                            '&:disabled': {
                                                opacity: 0.3
                                            }
                                        }}
                                    >
                                        <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />
                                    </IconButton>

                                    <IconButton
                                        size="small"
                                        onClick={() => moveItem(index, 'down')}
                                        disabled={index === menuItems.length - 1}
                                        sx={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '4px',
                                            width: 28,
                                            height: 28,
                                            '&:hover': {
                                                bgcolor: '#f5f5f5',
                                                borderColor: '#bdbdbd'
                                            },
                                            '&:disabled': {
                                                opacity: 0.3
                                            }
                                        }}
                                    >
                                        <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                </Box>
                            </Box>
                        </Paper>
                    ))}
                </Box>

                {/* Action Buttons */}
                {/* <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={handleCancel}
                        sx={{
                            px: 4,
                            py: 1.5,
                            borderColor: '#e0e0e0',
                            color: '#666',
                            textTransform: 'none',
                            fontSize: '15px',
                            fontWeight: 500,
                            '&:hover': {
                                borderColor: '#bdbdbd',
                                bgcolor: '#f5f5f5'
                            }
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                            px: 4,
                            py: 1.5,
                            bgcolor: '#dc3545',
                            textTransform: 'none',
                            fontSize: '15px',
                            fontWeight: 500,
                            boxShadow: 'none',
                            '&:hover': {
                                bgcolor: '#c82333',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        Save
                    </Button>
                </Box> */}
                <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} className='pt-5 px-2' style={{ marginLeft: "8px" }}>
                    <ButtonTheme disabled={saving} type='submit' variant="filled" color='primary' className='px-5 mx-2'>
                        {saving && 'Loading...'}
                        {!saving && 'Save'}
                    </ButtonTheme>
                    <ButtonTheme disabled={saving} onClick={() => setIsAdding(false)} variant="filled" className='px-5'>
                        Cancel
                    </ButtonTheme>
                </Grid>
            </Box>
        </Paper>

    );
};

export default AdjustMenu;